import React from 'react';

import BarGraph from 'components/Charts/BarGraph';
import Tooltip from 'modules/Prices/components/tooltip';
import Tick from 'modules/Prices/components/tick';

import { getLabels, roundValue } from 'modules/Prices/helpers';
import { getChartData } from 'modules/Prices/pages/price/components/GraphByMarkets/helpers';
import truncate from 'utils/truncate';
import { components } from '../../../../../../apiTyped/types';

const PriceMarketChart = ({
  data,
  wine,
  vintage,
  format,
  network,
  currency,
  markets,
  competitor,
  competitorVintage,
  activeRadioButton
}: {
  data: components['schemas']['DataDetail'][];
  wine: string | null;
  vintage: string | null;
  format: string | null;
  network: string | null;
  currency: string;
  markets: string[];
  competitor: string | null;
  competitorVintage?: string | null;
  activeRadioButton: string;
}) => {
  const dataChart = getChartData({
    data,
    wine,
    vintage,
    format,
    network,
    markets,
    competitor,
    competitorVintage
  });

  const labels = getLabels(dataChart, activeRadioButton, true);

  return (
    <BarGraph
      height={450}
      isAnimationActive={false}
      data={dataChart}
      tooltipOffset={{ x: -80, y: 0 }}
      labels={labels}
      showLabel
      renderTooltip={(props: []) => (
        <Tooltip data={props} labels={labels} currency={currency} />
      )}
      xAxisProps={{
        tickFormatter: (value: number) => truncate(value, 7),
        tick: (props: any) => <Tick {...props} />
      }}
      yAxisProps={{
        scale: 'linear',
        interval: 'preserveStart',
        tickFormatter: (value: any) =>
          value.toLocaleString('fr-FR', {
            style: 'currency',
            currency: currency ? currency : 'EUR',
            scale: 'linear',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
          }),
        domain: [0, (dataMax: number) => roundValue(dataMax + dataMax / 4)]
      }}
      colors={['#e25d34', '#1f2b37', '#a5aaaf', '#B1B7BD', '#C9D0D6']}
    />
  );
};

export default PriceMarketChart;
